export default __webpack_public_path__ + "static/media/base-plaque-two.82037d4b.png";